import { GA_MEASUREMENT_ID } from 'constants/env';

import { appEnvControl } from 'utils';

import { sanitizeParams } from './normalize';

const PacePromoAnalyticsEvent = {
  viewed: 'pace_promo_viewed',
  linkClicked: 'pace_promo_link_clicked',
  dismissed: 'pace_promo_dismissed',
} as const;

function isEnabled(): boolean {
  return typeof window !== 'undefined' && typeof window.gtag === 'function';
}

function send(name: string, params: Record<string, unknown> = {}) {
  if (!isEnabled()) return;

  try {
    const isProduction = appEnvControl.isEnv('production');

    window.gtag!('event', name, {
      ...sanitizeParams(params),
      send_to: GA_MEASUREMENT_ID,
      transport_type: 'beacon',
      ...(isProduction ? {} : { debug_mode: true, traffic_type: 'internal' }),
    });
  } catch (e) {
    console.error(e);
  }
}

function viewed() {
  send(PacePromoAnalyticsEvent.viewed);
}

function linkClicked(href: string | nil) {
  send(PacePromoAnalyticsEvent.linkClicked, { href });
}

function dismissed() {
  send(PacePromoAnalyticsEvent.dismissed);
}

const pacePromoAnalytics = {
  viewed,
  linkClicked,
  dismissed,
};

export { pacePromoAnalytics };
